export default __webpack_public_path__ + "static/media/events_banner.13066730.png";